import React from 'react';
import PropTypes from 'prop-types';
import { CmsEntities } from 'client/data/models/cms';
import { DEFAULT_CONTENT } from 'client/data/cms/content';
import { RELATED_CONTENT_CONFIG, TRUNCATED_HTML_HEIGHT } from 'site-modules/shared/constants/top-rated/top-rated';
import { TypeJellybeanNavV2 } from 'site-modules/shared/components/type-jellybean-nav/type-jellybean-nav-v2';
import { ResearchSharedSubnav } from 'site-modules/shared/components/editorial/research-shared-subnav/research-shared-subnav';
import { TruncatedHtml } from 'site-modules/shared/components/editorial/truncated-html/truncated-html';
import { VehicleSection } from 'site-modules/editorial/components/top-rated/vehicle-section/vehicle-section';
import { RelatedContent } from 'site-modules/shared/components/editorial/related-content/related-content';
import { HighlightVideo } from 'site-modules/editorial/components/highlight-video/highlight-video';

const MOBILE_PLATFORM = 'mobile';

const ENTRY_RENDER_TYPE = {
  HTML: 'html',
  CARD: 'card',
  AD: 'ad',
  RELATED_CONTENT: 'related-content',
};
const ENTRY_ID = {
  RESEARCH_SUBNAV: 'research-subnav',
  BROWSE_TYPES: 'browse-types',
  HIGHLIGHT_VIDEO: 'highlight-video',
};

export function ResearchEntry({ entry = DEFAULT_CONTENT, openVideoModal = null, isMobile = false }) {
  const platform = entry.metadata('platform').value();
  if (platform && (platform === MOBILE_PLATFORM) !== isMobile) {
    return null;
  }

  const entryRenderType = entry.metadata('renderType').value();
  let renderEntry;

  if (entryRenderType) {
    switch (entryRenderType) {
      case ENTRY_RENDER_TYPE.HTML: {
        if (entry.metadata('htmlContent').value()) {
          renderEntry = <TruncatedHtml entry={entry} minHeight={TRUNCATED_HTML_HEIGHT} />;
        }
        break;
      }
      case ENTRY_RENDER_TYPE.CARD: {
        renderEntry = <VehicleSection entry={entry} openVideoModal={openVideoModal} isMobile={isMobile} />;
        break;
      }
      case ENTRY_RENDER_TYPE.RELATED_CONTENT: {
        renderEntry = <RelatedContent entry={entry} config={RELATED_CONTENT_CONFIG} isMobile={isMobile} />;
        break;
      }
      default: {
        break;
      }
    }
  } else {
    switch (entry.id) {
      case ENTRY_ID.RESEARCH_SUBNAV: {
        renderEntry = <ResearchSharedSubnav itemTrackingId="inline_article_view_content" />;
        break;
      }
      case ENTRY_ID.BROWSE_TYPES: {
        renderEntry = <TypeJellybeanNavV2 headingClassName="heading-3 mt-2" includeSymbolSheet />;
        break;
      }
      case ENTRY_ID.HIGHLIGHT_VIDEO: {
        renderEntry = <HighlightVideo entry={entry} openVideoModal={openVideoModal} isMobile={isMobile} />;
        break;
      }
      default: {
        break;
      }
    }
  }

  if (!renderEntry) {
    return null;
  }

  return renderEntry;
}

ResearchEntry.propTypes = {
  openVideoModal: PropTypes.func,
  entry: CmsEntities.Content,
  isMobile: PropTypes.bool,
};
